<template>
	<div id="centerWidth" :style="{'height':windowHeight+'px'}" style="overflow: auto;" @scroll="scrollEvent($event)">
		<div class="centerWidth">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>查.一分一段表</span>
			</div>
			<section class="gaokao-content">
				<div class="one flex float">
					<div class="one_left">
						<div class="one_li">
							<p>高考分数/预估分数：</p>
							<!-- <el-input v-model="score" placeholder="请输入内容"></el-input> -->
							<el-input-number v-model="score" placeholder="请输入分数" :controls="false"
								style="width: 100%;" />
						</div>
						<div class="one_li" style="margin-top: 30px;">
							<p>请选择科目类别：</p>
							<el-select v-model="value" placeholder="请选择" style="width: 100%;"
								@change="handleTypeChange">
								<el-option v-for="(item, index) in options" :key="index" :label="item.label"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<el-button type="primary" @click="handleChart"
							style="width: 100%;display: block;margin-top: 30px;background-color: #0079fe;">开始查询
						</el-button>
					</div>
					<div class="one_you">
						<h6 class="flex zhong">
							<i></i>
							位次查询
						</h6>
						<div class="one_div flexFloat">
							<hgroup class="flex">
								<p>位次区间</p>
								<p>{{ currData.Min ? currData.Min + '-' + currData.Max : '暂无' }}</p>
							</hgroup>
							<hgroup class="flex">
								<p>同分位人数</p>
								<p>{{ currData.Paragraph || '暂无' }}</p>
							</hgroup>
							<hgroup class="flex">
								<p>建议位次</p>
								<p>{{ currData.Cumulative || '暂无' }}</p>
							</hgroup>
						</div>

						<div class="shu_gao">
							<p>人数</p>
							<div id="myChart" :style="{ width: '828px', height: '252px' }"></div>
						</div>
					</div>
				</div>

				<!--
            2.23
            <article class="major-share">
				<ul>
					<li class="flex wrap">
						<label>科类：</label>
						<div class="fenNum_div">
							<p :class="isClassfiy == 0 ? 'on' : ''" @click="classFiyClick(0)">理科或选物理</p>
							<p :class="isClassfiy == 1 ? 'on' : ''" @click="classFiyClick(1)">文科或选历史</p>
							<p :class="isClassfiy == 2 ? 'on' : ''" @click="classFiyClick(2)">不分文理</p>
						</div>
					</li>
					<li class="flex wrap">
						<label>招生地区：</label>
						<div class="fenNum_div">
							<p :class="currCityName == '' ? 'on' : ''" @click="cityClick('')">全部</p>
							<p :class="item.Name == currCityName ? 'on' : ''" @click="cityClick(item.Name)" v-for="(item, index) in cityList" :key="index">{{ item.Name }}</p>
						</div>
					</li>
				</ul>
			</article> -->

				<div style="overflow: hidden;">
					<article class="table">
						<hgroup class="flex">
							<p>年份</p>
							<p>招生地区</p>
							<p>文理分科</p>
							<p>分数</p>
							<p>段内人数</p>
							<p>累计人数</p>
							<p>备注</p>
						</hgroup>
						<ul>
							<li class="flex" v-for="(item, index) in tableList" :key="index">
								<p>{{ item.Year }}</p>
								<p>{{ item.EnrollmentArea }}</p>
								<p>{{ item.CandidatesType }}</p>
								<p>{{ item.Score }}</p>
								<p>{{ item.Paragraph }}</p>
								<p>{{ item.Cumulative }}</p>
								<p>{{ item.Remarks }}</p>
							</li>
						</ul>
					</article>
					<!-- <div class="flex xend major-page" style="margin: 20px auto;">
						<el-pagination background layout="prev, pager, next" :page-size="pageSize"
							@current-change="GetPageList" :current-page="page" :total="totleNum"></el-pagination>
					</div> -->
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				score: undefined,
				options: [{
						label: '理科或选物理',
						value: '理科,物理'
					},
					{
						label: '文科或选历史',
						value: '文科,历史'
					},
					{
						label: '不分文理',
						value: '不分文理'
					}
				],
				value: '不分文理',
				// 以上2.13
				isClassfiy: 2,
				isCity: 0,
				cityList: [],
				subjectName: '',
				totleNum: 0,
				page: 1,
				pageSize: 10,
				tableList: [],
				currCityName: '',
				candidatesType: '',
				windowHeight: document.documentElement.clientHeight,
				// 列表是否在加载
				listLoading: false,
				// 列表是否加载完毕
				listFinished: false,
				// 位次统计图上的数据
				currData: {},
				// 位次统计图表数据
				chartList: [],
				// 图标数据加载中
				chartLoad: false,
				// 冒泡点数据
				markPointData: {}
			};
		},
		// 加载
		created() {
			this.$store.state.shop.currentProvince.map(ent => {
				if (ent.Code === this.$store.state.user.user.ProvinceCode.toString()) {
					this.cityList.push(ent);
				}
			});
			this.GetList(1);
			if (this.$route.query.key) {
				this.$api.reduceUserCount({
					key: this.$route.query.key
				});
			} else {
				this.$router.back(-1);
			}
		},
		watch: {
			windowHeight(val) {
				const that = this;
				console.log('实时屏幕高度：', val, that.windowHeight);
			}
		},
		mounted() {
			const that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.windowHeight = window.fullHeight;
				})();
			};
			// this.drawLine();
		},
		methods: {
			scrollEvent(e) {
				const scrollBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
				if (scrollBottom < 30) {
					if (!this.listLoading && !this.listFinished) {
						this.GetList(this.page + 1);
					}
				}
			},
			drawLine() {
				const that = this;
				// 基于准备好的dom，初始化echarts实例
				const myChart = this.$echarts.init(document.getElementById('myChart'));
				// myChart.removeAttribute('_echarts_instance_');
				myChart.clear();
				// 绘制图表
				const xData = this.chartList.map(el => {
					return el.Score;
				});
				const yData = this.chartList.map(el => {
					return el.Paragraph;
				});
				const option = {
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							const data = params[0];
							const index = data.dataIndex;
							const score = data.name;
							const tmp = that.chartList[index];
							return `分数：${score},同分人数${tmp.Paragraph}<br>位次：${tmp.Min}-${tmp.Max}`;
						}
					},
					grid: {
						left: '5%',
						right: '0%',
						top: '-5%',
						bottom: '8%'
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: xData
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: yData,
						type: 'line',
						lineStyle: {
							color: '#7cb4eb'
						},
						areaStyle: {
							color: '#cae1f7'
						}
					}]
				};
				if (this.markPointData.x) {
					option.series[0].markPoint = {
						data: [{
							xAxis: this.markPointData.x,
							yAxis: this.markPointData.y
						}],
						symbolSize: [25, 25],
						itemStyle: {
							normal: {
								color: '#1fb0ff'
							}
						}
					};
				}
				myChart.setOption(option);
			},
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},
			handleTypeChange() {
				if (this.value === '不分文理') {
					this.candidatesType = '';
				} else {
					this.candidatesType = this.value;
				}
				this.GetList(1);
			},
			classFiyClick(index) {
				this.isClassfiy = index;
				console.log('classFiyClick', index);
				this.candidatesType = index === 0 ? '理科' : index === 1 ? '文科' : '';
				this.GetList(1);
			},
			cityClick(name) {
				if (this.currCityName === name) {
					this.currCityName = '';
				} else {
					this.currCityName = name;
				}
				this.GetList(1);
			},
			// 获取代理城市
			GetCity: function() {
				var that = this;
				that.$api.HtppRequest(
					'SystemData/GetShopCity',
					'GET', {},
					function(res) {
						console.log('获取代理城市');
						console.log(res);
						if (res.flag) {
							that.cityList = res.list;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取列表
			GetList: function(page) {
				var that = this;
				that.listLoading = true;
				that.$api.HtppRequest(
					'SystemData/GetOneParagraphByPageList',
					'POST', {
						page: page,
						size: that.pageSize,
						enrollmentArea: that.currCityName,
						candidatesType: that.candidatesType
					},
					function(res) {
						console.log('获取列表');
						that.listLoading = false;
						console.log(res);
						if (res.flag) {
							const list = res.list;
							if (page === 1) {
								that.tableList = list;
							} else {
								that.tableList.push(...list);
							}
							that.listFinished = list.length < that.pageSize;
							that.page = page;
							that.totleNum = res.totle;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 点击开始查询
			handleChart() {
				if (!this.score) {
					this.$util.showError('请输入高考分数/预估分数');
					return;
				}
				if (this.chartLoad) {
					return;
				}
				this.getChart();
				this.GetList(1);
			},
			// 获取图标数据
			getChart() {
				const that = this;
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				that.$api.HttpGet('SystemData/OneParagraphChart', {
					candidatesType: that.value,
					score: that.score
				}, function(res) {
					that.chartLoad = false;
					loading.close();
					if (res.flag) {
						that.currData = res.curr || {};
						const list = res.list;
						list.map(el => {
							if (el.Paragraph < 0) {
								el.Paragraph = '0';
							}
						});
						that.chartList = list;
						if (res.curr) {
							// 如果用户输入的分数在列表中
							list.map((el, index) => {
								const score = el.Score.replace(/\D/g, '');
								if (that.score === parseInt(score)) {
									console.log('score', el, index);
									that.markPointData = {
										x: index,
										y: parseInt(el.Paragraph)
									};
								}
							});
						} else {
							that.markPointData = {};
						}
						that.drawLine();
					}
				}, function(err) {
					console.log(err);
				});
			},
			// 获取其他页
			GetPageList: function(val) {
				var that = this;
				that.GetList(val);
				console.log(`当前页: ${val}`);
			}
		}
	};
</script>

<style scoped>
	.shu_gao p {
		font-size: 12px;
		color: #999;
	}

	.shu_gao {
		width: 100%;
		height: 270px;
		margin-top: 20px;
	}

	.one_div hgroup p:last-child {
		border-left: solid 1px #d9d9d9;
		color: #0079fe;
	}

	.one_div hgroup p {
		width: 120px;
		line-height: 40px;
	}

	.one_div hgroup {
		border: solid 1px #d9d9d9;
		font-size: 14px;
		color: #000;
		text-align: center;
		border-radius: 4px;
	}

	.one_you>h6 i {
		border-radius: 50px;
		width: 3px;
		display: block;
		height: 18px;
		margin-right: 12px;
		background-color: #005270;
	}

	.one_you>h6 {
		padding-bottom: 16px;
		font-size: 16px;
		color: #000;
		font-weight: normal;
	}

	.one_you {
		width: calc(100% - 270px);
	}

	/deep/.el-input__inner {
		background-color: #f6faff;
		border-color: #0079fe;
		text-align: center;
	}

	.one_li p {
		font-size: 14px;
		color: #000;
		padding-bottom: 20px;
	}

	.one_left {
		width: 230px;
	}

	.one {
		border: solid 1px #dddddd;
		padding: 30px;
		margin-bottom: 30px;
	}

	/* one */

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
	}

	/* 01 */
	.fenNum_div p {
		width: 100px;
		height: 40px;
		line-height: 40px;
		float: left;
		color: #333;
		font-size: 14px;
		margin-right: 20px;
		text-align: center;
		border-radius: 4px;
		cursor: pointer;
	}

	.fenNum_div p:hover {
		opacity: 0.7;
	}

	.fenNum_div p.on:hover {
		opacity: 1;
	}

	.fenNum_div p.on {
		background-color: #333;
		color: #fff;
	}

	.fenNum_div {
		width: calc(100% - 200px);
		margin-left: 20px;
	}

	.major-share label {
		font-size: 14px;
		color: #333;
		display: block;
		width: 100px;
		line-height: 40px;
		text-align: right;
	}

	.major-share ul li:first-child {
		margin-top: 0;
	}

	.major-share ul li {
		margin-top: 10px;
	}

	.major-share ul {
		overflow: hidden;
	}

	/* major-share */

	.gaokao-btn {
		width: 90px;
		font-size: 14px;
		margin-left: 0 !important;
	}

	.fenNum_head p.on {
		background-color: #333;
		color: #fff;
	}

	.fenNum_head p.on:hover {
		opacity: 1;
	}

	.fenNum_head p {
		font-size: 16px;
		color: #333;
		width: 180px;
		height: 38px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		float: left;
		border: solid 1px #333;
		border-bottom: none;
		text-align: center;
		line-height: 38px;
		cursor: pointer;
	}

	.fenNum_head p:hover {
		opacity: 0.7;
	}

	.fenNum_head {
		overflow: hidden;
		border-bottom: solid 2px #333;
		margin-top: 40px;
	}

	/* fenNum_head */

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	/* major-share */
	.major-share {
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #eaeaea;
		margin: 20px auto 30px auto;
		padding: 30px 0;
	}

	.major-share-con {
		width: 75%;
		height: auto;
		overflow: ;
		display: flex;
		flex-wrap: wrap;
	}

	.share-li {
		width: 50%;
		display: flex;
		align-items: center;
		/* justify-content: center; */
		margin: 10px 0;
	}

	.share-li p {
		font-size: 14px;
		color: #333;
		width: 100px;
		text-align: right;
		margin-right: 20px;
	}

	.share-li input {
		width: 270px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: block;
		border-radius: 5px;
		background-color: #fff;
		color: #333;
		font-size: 14px;
	}

	.share-li input::-webkit-input-placeholder {
		color: #999;
	}

	.share-li input:-moz-placeholder {
		color: #999;
	}

	.share-li input:-ms-input-placeholder {
		color: #999;
	}

	.sjWidth {
		width: 270px;
	}

	.major-btn01 {
		width: 25%;
		display: flex;
		align-items: flex-end;
	}

	.major-btn01 button {
		margin: 10px auto;
	}

	/* major-list */
	.major-list {
		width: 100%;
		height: auto;
		margin-top: 15px;
	}

	.major-list ul {
		width: 100%;
		height: auto;
	}

	.major-list ul li {
		border: 1px solid #eee;
		width: 100%;
		height: auto;
		padding: 20px 30px;
		margin-bottom: 20px;
		position: relative;
	}

	.major-li01 {
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
	}

	.major-li-btn {
		width: 23%;
	}

	.major-li-btn p {
		width: 130px;
		height: 33px;
		line-height: 33px;
		text-align: center;
		background-color: #333;
		font-size: 16px;
		color: #fff;
		border-radius: 50px;
	}

	.major-li01-right {
		width: 80%;
		display: flex;
	}

	.major-li01-right p {
		width: 20%;
		display: flex;
		align-items: center;
		line-height: 33px;
	}

	.major-li01-right p span {
		font-size: 15px;
		color: #999;
	}

	.major-li01-right p span:last-child {
		color: #333;
	}

	.major-li02 {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.major-li02 p {
		font-size: 14px;
	}

	.major-txt01 {
		width: 75px;
		color: #999;
	}

	.major-txt02 {
		width: calc(100% - 120px);
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.major-more {
		width: 45px;
		color: #333;
		text-align: right;
		cursor: pointer;
	}

	.major-txt04 {
		color: #333;
	}

	.major-more-con {
		position: absolute;
		width: 98%;
		height: auto;
		background: rgba(0, 0, 0, 0.7);
		padding: 20px;
		font-size: 15px;
		color: #fff;
		left: 1%;
		bottom: 0;
		border-radius: 5px;
		margin-bottom: -14px;
		z-index: 1;
	}

	.major-more-con::after {
		position: absolute;
		content: '';
		right: 0;
		top: 0;
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-bottom: 14px solid rgba(0, 0, 0, 0.7);
		margin-top: -14px;
		margin-right: 24px;
	}

	.major-page {
		margin-bottom: 30px;
	}

	.widthx {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.widthx .major-li01-right {
		width: 100%;
	}

	.widthx .major-li01-right p:first-child {
		min-width: 22.2%;
	}

	.widthx .major-li01-right p:nth-child(2) {
		width: 32.3%;
	}

	.lastIndex .major-li01-right p {
		width: 35%;
	}
</style>
